import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
        <path
          d="
        M 57.5 62 
        L 51 62
        L 47 51.5 
        L 30 51.5
        L 26 61.5
        L 19.5 61.5 
        L 35.5 24 
        L 42 24
        L 57.5 61.5
        Z 
        M 38.5 30.5
        L 32.5 46 
        L 44.5 46
        L 38.5 30.5         
        Z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
);

export default IconLogo;
